import * as React from "react";
import type { SVGProps } from "react";
const SvgTrain = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="m6 20.4-1.8 2.4m16.119-.02-1.853-2.36M8.4 16.872V16.8m7.2.072V16.8m-10.8-3h15m-7.8-9v8.4m-3-12h6M6.565 20.4h10.87a2.965 2.965 0 0 0 2.965-2.965v-9.67A2.965 2.965 0 0 0 17.435 4.8H6.565A2.965 2.965 0 0 0 3.6 7.765v9.67A2.965 2.965 0 0 0 6.565 20.4Z"
    />
  </svg>
);
export default SvgTrain;
